import React from 'react';
import { Switch as RNSwitch, SwitchProps as RNSwitchProps } from 'react-native';

import { useTheme } from '@/components/theme-provider';

export interface SwitchProps extends RNSwitchProps {
	value: boolean;
	onValueChange: (value: boolean) => void;
}

export const Switch: React.FC<SwitchProps> = ({
	value,
	onValueChange,
	...props
}) => {
	const theme = useTheme();

	return (
		<RNSwitch
			value={value}
			onValueChange={onValueChange}
			trackColor={{
				false: theme.colors.outline,
				true: theme.colors.primary,
			}}
			thumbColor={value ? theme.colors.onPrimary : theme.colors.surface}
			{...props}
		/>
	);
};
